import {UIEventDefinition} from "./uievent-definition";

export class UIEventModel {

  private readonly definition: UIEventDefinition;

  constructor(definition: UIEventDefinition) {
    this.definition = definition;
  }

  getTableName(): string {
    return this.getDefaultedField("_tableClass");
  }

  getEventName(): string {
    return this.getDefaultedField("_eventName");
  }

  getEventType(): string {
    return this.getDefaultedField("_eventType");
  }

  getFieldName(): string {
    return this.getDefaultedField("_field");
  }

  getScript(): string {
    return this.getDefaultedField("_script");
  }

  private getDefaultedField(property: any, defaultValue?: any) {
    const value = this.definition[property];
    return value !== null && value !== undefined ? value : defaultValue;
  }

  static create(definition: UIEventDefinition): UIEventModel {
    return new UIEventModel(definition);
  }

  static EVENT_TYPE_FIELD =   "event_type_field";
  static EVENT_TYPE_FORM =    "event_type_form";
}
